export default {
  namespaced: true,
  state: {
    isSidebarOpen: true,
    isFullWidth: false,
    search: {
      placeholder: null,
      route: null,
    },
    searchPlaceholder: null,
    hasErrors: false,
    errors: [],
  },
  mutations: {
    setIsFullWidth: (state, isFullWidth) => {
      state.isFullWidth = isFullWidth;
    },
    setSearch: (state, search) => {
      state.search = search;
    },
    resetSearch: (state) => {
      state.search = {
        placeholder: null,
        route: null,
      };
    },
    setHasErrors: (state, hasErrors) => {
      state.hasErrors = hasErrors;
    },
    setErrors: (state, errors) => {
      state.errors = errors;
    },
    resetErrors: (state) => {
      state.errors = [];
    },
    addError: (state, error) => {
      if (typeof error === 'string') {
        error = {
          propertyPath: 'generic',
          message: error,
        };
      }

      state.errors.push(error);
    },
  },
};
